/** Created by azhou on 2019/3/26.*/
<template>
  <ul class="list-item">
    <li class="w-50 list-item-col breakword">{{item.order_no || item.out_trade_no || '平台打款'}}</li>
    <!--非采购商身份查看项-->
    <li class="w-50 list-item-col" v-show="!traAtour">{{item.tid | formatVar('EXPTYPES')}}</li>
    <li class="w-50 list-item-col" v-show="!traAtour"
        :class="[item.isadd ? 'text-success' : 'text-danger']">
      {{item.isadd ? '+' : '-'}}{{item.money/100 | formatMoney}} 元
    </li>
    <li class="w-50 list-item-col" v-show="!traAtour">{{item.red_packet_money ? (item.red_packet_money / 100).toFixed(2) + '元' : '-'}}</li>
    <li class="w-50 list-item-col" v-show="!traAtour">
      {{item.money_end/100 | formatMoney}} 元
    </li>
    <!--采购商和导游查看项-->
    <li class="w-50 list-item-col" v-show="traAtour">
      {{item.total_fee/100 | formatMoney}} 元
    </li>
    <li class="w-50 list-item-col" v-show="storeInfo.type == 4">{{item.red_packet_money ? (item.red_packet_money / 100).toFixed(2) + '元' : '-'}}</li>
    <li class="w-50 list-item-col">
      {{item.adtime | formatTimestamp(1)}}
    </li>
    <li class="w-50 list-item-col breakword">{{item.trade_no || item.remark}}</li>
    <li class="w-50 list-item-col" v-show="traAtour">
      {{item.channel_type | formatVar('payChannel')}}
      （<span v-if="item.credit">{{item.credit | formatVar('payType')}}</span><span v-else>其他</span>）
      <!-- （{{item.credit | formatVar('payType')}}） -->
    </li>
    <li class="w-50 list-item-col-end" v-show="traAtour">
      {{item.terminal_name}}
    </li>
  </ul>
</template>

<script>
  import { mapGetters } from 'vuex'

  export default {
    name: 'PayDetail',
    props:{
      item:{}
    },
    computed: {
      ...mapGetters(['storeInfo']),
       //看门店类型是采购商或导游
      traAtour () { 
        if (this.storeInfo.type == 2 || this.storeInfo.type == 4) return true
        else return false
      },
    }
  }
</script>
